module.exports = __webpack_public_path__ + "img/i.94462576.jpg";